import React from "react";
import Footer from "./Footer";
import "../css/shop.scss";
import { Link } from "react-router-dom";
import productData from "../Datas/productData";
import Header from "./Header";

function Shop() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="shop main">
      <Header />

      <main className="main-content">
        <section className="top-sellers">
          <div className="top-sellers-container">
            <h2 className="top-sellers-title">SHOP!</h2>

            <div className="top-sellers-grid">
              {productData.map((product) => (
                <div key={product.id} className="seller-card">
                  <Link to={`/shopDetails/${product.id}`} onClick={toTop}>
                    <div className="seller-image-wrapper">
                      <img
                        src={product.images[0]}
                        alt={product.name}
                        className="seller-image"
                      />
                    </div>

                    <div className="seller-info">
                      <div className="seller-category">
                        {product.category.toUpperCase()}
                      </div>

                      <h3 className="seller-title">{product.name}</h3>

                      <div className="seller-price">${product.price}</div>

                      <button className="add-to-cart-btn">ADD TO CART</button>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default Shop;
